/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Strength_Empty_TitleInputs */

const en_us2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strength in the making`)
};

const pt_br2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força em construção`)
};

const es_419_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuerza en construcción`)
};

const pt_pt2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Força em construção`)
};

const fr_fr2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Force en construction`)
};

const de_de2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraft im Aufbau`)
};

const it_it2_wrapped_strength_empty_title = /** @type {(inputs: Wrapped_Strength_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forza in costruzione`)
};

/**
* | output |
* | --- |
* | "Strength in the making" |
*
* @param {Wrapped_Strength_Empty_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_strength_empty_title = /** @type {((inputs?: Wrapped_Strength_Empty_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Strength_Empty_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_strength_empty_title(inputs)
	if (locale === "es-419") return es_419_wrapped_strength_empty_title(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_strength_empty_title(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_strength_empty_title(inputs)
	if (locale === "de-DE") return de_de2_wrapped_strength_empty_title(inputs)
	if (locale === "it-IT") return it_it2_wrapped_strength_empty_title(inputs)
	return en_us2_wrapped_strength_empty_title(inputs)
});
export { wrapped_strength_empty_title as "wrapped.strength_empty_title" }